// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"627ae569","239":"2a714544","455":"6ea87503"}[chunkId] + ".chunk.js";
};